import React from "react";
import { InfoLine, InfoVert } from "../";
import { FormatSSN, FormatDate } from "_assets/js/helpers";
import "./Personal.scss";

const AddressList = (props) => {
  const { address } = props;

  return (
    <div className="item-list">
      <div>
        {address?.street?.number} {address?.street?.preDirectional}{" "}
        {address?.street?.name} {address?.street?.type}
        <br />
        {address?.location?.city}, {address?.location?.state}{" "}
        {address?.location?.zipCode?.substring(0, 5)}
      </div>
      {address?.status && (
        <p>
          {address.status === "CURRENT"
            ? "Current"
            : address.status === "PREVIOUS"
            ? "Previous"
            : address.status}
        </p>
      )}
      {address?.dateReported && (
        <p>Reported {FormatDate(address?.dateReported?.value)}</p>
      )}
    </div>
  );
};

function Personal(props) {
  const { report } = props;

  // Extract TransUnion personal data from indicative section
  const indicative = report?.indicative || {};
  const primaryName = indicative?.names?.[0]?.person;
  const addresses = indicative?.addresses || [];
  const currentAddress =
    addresses.find((a) => a.status === "CURRENT") || addresses[0];
  const otherAddresses = addresses.filter((a) => a.status !== "CURRENT");
  const ssn = indicative?.socialSecurities?.[0]?.number;
  const dob = indicative?.dateOfBirths?.[0]?.value;
  const employments = indicative?.employments || [];
  const currentEmployment = employments[0];
  const otherEmployment = employments[1];

  return (
    <div id={props.id} className="wzrd-box personal">
      <div className="wzrd-header">
        <h3>Personal Information</h3>
      </div>
      <div className="wzrd-body">
        <InfoLine
          title="Best Name"
          info={`${primaryName?.first || ""} ${primaryName?.middle || ""} ${
            primaryName?.last || ""
          }`}
        />
        {ssn && (
          <InfoLine title="Social Security Number" info={FormatSSN(ssn)} />
        )}
        {dob && <InfoLine title="Date of Birth" info={`${FormatDate(dob)}`} />}
        {currentEmployment && (
          <InfoLine
            title="Best Employer"
            info={currentEmployment?.employer?.unparsed}
          />
        )}
        {currentEmployment?.occupation && (
          <InfoLine title="Occupation" info={currentEmployment?.occupation} />
        )}
        {otherEmployment && (
          <InfoLine
            title="Other Employer"
            info={otherEmployment?.employer?.unparsed}
          />
        )}
        {currentAddress && (
          <InfoVert title="Best Address">
            <AddressList address={currentAddress} />
          </InfoVert>
        )}
        {otherAddresses && otherAddresses.length > 0 && (
          <InfoVert title="Other Address(es)" last>
            <div className="columns">
              {otherAddresses?.map((a, i) => (
                <AddressList key={`al-${i}`} address={a} />
              ))}
            </div>
          </InfoVert>
        )}
      </div>
    </div>
  );
}

export default Personal;
